import {
    ADD_DS_PL,
    DEL_DS_PL,
    DEL_ALLDS_PL,
    CHANGE_DS_PL,
    CHANGE_SELROW_PL,
    ISDEL_PL
} from './actions';

const initData = {
    ds: [
        //ID = データセットID
        //ZAttr = Z属性
        //→'dep' = 深度
        //→'elv' = 標高
        //ZVal = Z値
        //divNumX = X方向分割数
        //divNumY = Y方向分割数
        //estFlg = 推定フラグ（0=未推定  1=推定済み）
        //{ID: 1, ZAttr: 'dep', ZVal: 0, divNumX: 5 divNumY: 5, estFlg: 0}
    ],
    selRow: null,
    isDel: false
};

export function plReducer(state = initData, action) {
    switch (action.type) {
        case ADD_DS_PL:
            return addDsReduce(state, action);
        case DEL_DS_PL:
            return delDsReduce(state, action);
        case DEL_ALLDS_PL:
            return delAllDsReduce(state, action);
        case CHANGE_DS_PL:
            return changeDsReduce(state, action);
        case CHANGE_SELROW_PL:
            return changeSelRowReduce(state, action);
        case ISDEL_PL:
            return isDelReduce(state, action);
        default:
            return state;
}
}

export function addDsReduce(state, action) {
    return {
        ...state,
        ds: state.ds.concat({ID: action.ID, ZAttr: 'dep', ZVal: 0, divNumX: 20, divNumY: 20, estFlg: 0})
    };
}

export function delDsReduce(state, action) {
    return {
        ...state,
        ds: state.ds.filter((el, index) => index !== action.rowID)
    };
}

export function delAllDsReduce(state) {
    return {
        ...state,
        ds: []
    };
}

export function changeDsReduce(state, action) {
    return {
        ...state,
        ds: action.ds
    };
}

export function changeSelRowReduce(state, action) {
    return {
        ...state,
        selRow: action.rowID
    };
}

export function isDelReduce(state, action) {
    return {
        ...state,
        isDel: action.isDel
    };
}